import { createServerOnlyFn } from "@tanstack/react-start";
import { ariVerificationResponse } from "./page.server";
import { resolveAriVerificationRequest } from "./resolve.server";

export const ariVerificationRoute = {
    server: {
        handlers: {
            GET: createServerOnlyFn(() => ariVerificationResponse()),
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                resolveAriVerificationRequest(
                    request,
                    process.env.WAGS_API_KEY ?? "",
                ),
            ),
        },
    },
};

export const ariVerificationShortRoute = {
    server: {
        handlers: {
            GET: createServerOnlyFn(() => ariVerificationResponse()),
            POST: createServerOnlyFn(
                ({
                    request,
                    params,
                }: {
                    request: Request;
                    params: { id: string };
                }) =>
                    resolveAriVerificationRequest(
                        request,
                        process.env.WAGS_API_KEY ?? "",
                        params.id,
                    ),
            ),
        },
    },
};
